import * as ActionTypes from "../ActionTypes";

export const GetMprDetailsAction = (params) => {
    return {
        type: ActionTypes.ATS_MPR_DETAILS_GET_REQUEST,
        params
    };
};

export const UpdateMprDetailsAction = (params, callback) => {
    return {
        type: ActionTypes.ATS_MPR_DETAILS_UPDATE_REQUEST,
        params,
        callback
    };
};
